module.exports = __webpack_public_path__ + "img/miniatura.d51fefb3.svg";